import styled from '@emotion/styled';
import theme from '../../styles/theme';
import { rem } from '../../styles/theme/layout';

export interface CheckmarkProps {
  color?: 'white' | 'light-blue';
}

const Checkmark = styled('span')<CheckmarkProps>`
  display: inline-block;
  &::after {
    content: '';
    border: solid;
    border-radius: 1px;
    border-width: 0 3px 3px 0;
    display: block;
    height: 12px;
    transform: rotate(45deg);
    width: 6px;
    position: relative;
    top: ${rem(-2)};
    border-color: ${({ color }) =>
      color === 'light-blue' ? theme.colors.lightBlue : theme.colors.white};
  }
`;

Checkmark.defaultProps = {
  color: 'white',
};

export default Checkmark;
